import React, { useEffect } from 'react';
import { Loader } from '@googlemaps/js-api-loader';

const GoogleMapsComponent = ({ apiKey, apiOptions, onLoadFailed }) => {
  useEffect(() => {
    const init = async () => {
      if (!apiKey) return;

      try {
        if (!window.google || !window.google.maps) {
          const loader = new Loader({ apiKey, ...apiOptions });

          const [maps, places, marker] = await Promise.all([
            loader.importLibrary('maps'),
            loader.importLibrary('places'),
            loader.importLibrary('marker'),
          ]);

          window.google.maps = { ...maps, places, marker }; // Ensure libraries are assigned
        }

        const map = new window.google.maps.Map(document.getElementById('map'), {
          center: { lat: 37.7749, lng: -122.4194 }, // San Francisco
          zoom: 10,
        });

        // Use google.maps.marker.AdvancedMarkerElement
        const marker = new window.google.maps.marker.AdvancedMarkerElement({
          position: { lat: 37.7749, lng: -122.4194 },
          map: map,
          title: 'San Francisco',
        });

      } catch (error) {
        console.error('Google Maps API failed to load:', error);
        if (typeof onLoadFailed === 'function') onLoadFailed(error);
      }
    };

    init();
  }, [apiKey, apiOptions, onLoadFailed]);

  return <div id="map" style={{ width: '100%', height: '400px' }}></div>;
};

export default GoogleMapsComponent;
